import React from 'react';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import Pagination from './../../Pagination';
import numeral from 'numeral';

const Table = React.memo((props) => {
    let permissions = [];
    if (props.user && props.user.uth_permissions != null) {
        permissions = JSON.parse(props.user.uth_permissions);
    }

    const hendleDownloadImage = (url) => {
        window.open(url);
    };

    const handleShowFormModal = (id) => {
        props.setIdModal(id);
        props.setPromotionalItem(id);
        props.showFormModal();
    };

    const handleDeleteModal = (id) => {
        props.setIdModal(id);
        props.showDeleteModal();
    };

    const renderPromotionalItems = () => {
        if (props.fetching) {
            return (
                <tr>
                    <td colSpan="5"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (props.promotionalItems.length === 0) {
            return (
                <tr>
                    <td colSpan="5">No results</td>
                </tr>
            );
        }

        return props.promotionalItems.map((promotionalItem) => {
            if (parseInt(promotionalItem.id) === 20 || parseInt(promotionalItem.id) === 22) {
                return null;
            }

            let editIcon = null;
            if (permissions.includes('promotional-edit')) {
                editIcon = (
                    <Tooltip title="Edit" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-edit info-icon" onClick={handleShowFormModal.bind(this, promotionalItem.id)} />
                    </Tooltip>
                );
            }

            let deleteIcon = null;
            if (permissions.includes('promotional-delete')) {
                deleteIcon = (
                    <Tooltip title="Delete" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-trash trash-icon" onClick={handleDeleteModal.bind(this, promotionalItem.id)} />
                    </Tooltip>
                );
            }

            return (
                <tr key={promotionalItem.id}>
                    <td>{promotionalItem.id}</td>
                    <td>{promotionalItem.sku}</td>
                    <td>{promotionalItem.name}</td>
                    {/* <td>{promotionalItem.uthealth_department_name}</td> */}
                    <td>{numeral(promotionalItem.current_inventory).format('0,0')}</td>
                    <td>
                        <div className="actions">
                            <Tooltip title="View Image" position="top" arrow size="small" className="action-tooltip">
                                <i className="fas fa-file-image pdf-icon" onClick={hendleDownloadImage.bind(this, promotionalItem.image_url)} />
                            </Tooltip>
                            {editIcon}
                            {deleteIcon}
                        </div>
                    </td>
                </tr>
            );
        });
    };

    const handleSort = (column, type) => {
        props.setSort(column, type);
    };

    const renderHeader = (label, field) => {
        let sortType = 'asc';
        let sortIcon = <i className="fas fa-sort" />;
        if (props.sort.column === field) {
            if (props.sort.type === 'desc') {
                sortIcon = <i className="fas fa-sort-down" />;
                sortType = 'asc';
            } else {
                sortIcon = <i className="fas fa-sort-up" />;
                sortType = 'desc';
            }
        }

        return <div onClick={handleSort.bind(this, field, sortType)}>{label} {sortIcon}</div>
    };

    return (
        <div className="table-container">
            <table className="table table-sm table-hover table-striped">
                <thead>
                    <tr>
                        <th style={{ minWidth: 50 }}>
                            <span className="sort-column">{renderHeader('ID', 'id')}</span>
                        </th>
                        <th style={{ minWidth: 150 }}>
                            <span className="sort-column">{renderHeader('SKU', 'sku')}</span>
                        </th>
                        <th>
                            <span className="sort-column">{renderHeader('Name', 'name')}</span>
                        </th>
                        {/* <th>
                            <span className="sort-column">{renderHeader('Department', 'uthealth_department_id')}</span>
                        </th> */}
                        <th>
                            <span className="sort-column">{renderHeader('Current Inventory', 'current_inventory')}</span>
                        </th>
                        <th style={{ width: 120 }}></th>
                    </tr>
                </thead>
                <tbody>{renderPromotionalItems()}</tbody>
            </table>
            <Pagination
                pagination={props.pagination}
                setActivePage={props.setActivePage}
            />
        </div>
    );
});

Table.propTypes = {

}

export default Table;
